// Local Functions
const isItemPreview = ({ metadata }) => ['draft', 'future'].includes(metadata.status);

// Module Exports
export { isItemPreview };
